export default __webpack_public_path__ + "static/media/smiley_3.5228a7c3.svg";